import _groupBy from 'lodash/groupBy'
import _orderBy from 'lodash/orderBy'
import { createFilterOption } from 'frontend/helpers/filterSelectorUtils'
import { useProductionHierarchyStore } from 'frontcore/store/production-hierarchy/useProductionHierarchyStore'

const getters = {
  getProductionHierarchy () {
    return useProductionHierarchyStore().productionHierarchy
  },
  getProductionHierarchyByLevel: () => ({ level, includeDisabled, disabledExceptions=[], selectedParents=[] }) => {
    const { getProductionHierarchyByLevel } = useProductionHierarchyStore()
    return _orderBy(
      getProductionHierarchyByLevel({ level, includeDisabled, disabledExceptions, selectedParents }),
      item => item.name.toLowerCase()
    )
  },
  getProductionHierarchyOptionsTree: () => ({ level, selectedIds, selectedParents=[] }) => {
    let filterOptions = []
    const disabledExceptionsArray = Array.isArray(selectedIds) ? selectedIds : [selectedIds]
    const filteredByLevel = getters.getProductionHierarchyByLevel()({
      level: level,
      includeDisabled: false,
      disabledExceptions: disabledExceptionsArray,
      selectedParents: selectedParents,
    })
    const parentLevels = _groupBy(filteredByLevel, 'parent')

    Object.entries(parentLevels).forEach(([parentLevel, children]) => {
      const { productionHierarchy } = useProductionHierarchyStore()
      const parentName = productionHierarchy.find(item => item.id == parentLevel)?.name
      const headerOptions = parentName ? { header: parentName } : {}

      filterOptions = [
        ...filterOptions,
        headerOptions,
        ..._orderBy(children, 'name').map(hierarchy => createFilterOption({
          value: hierarchy.id,
          text: hierarchy.name,
          group: parentName,
          isDisabled: !hierarchy.enabled,
        })),
      ]
    })
    return filterOptions
  },
  getProductionHierarchyOptions: () => (level) => {
    const filteredByLevel = getters.getProductionHierarchyByLevel()({
      level: level,
      includeDisabled: false,
    })
    return filteredByLevel.map(hierarchy => {
      return createFilterOption({
        value: hierarchy.id,
        text: hierarchy.name,
        isDisabled: !hierarchy.enabled,
      })
    })
  },
  getProductionHierarchyById: () => (id) => {
    const { productionHierarchy } = useProductionHierarchyStore()
    return productionHierarchy.find(item => item.id === id)
  },
  getProductionHierarchyParents: () => (selectedIds) => {
    const { productionHierarchy } = useProductionHierarchyStore()
    const parent = productionHierarchy.filter(
      item => selectedIds.includes(item.id)).map(item => item.parent)
    return [...new Set(parent)]
  },
  getProductionHierarchyAscendants: () => (selectedIds) => {
    const ascendants = []
    selectedIds.forEach(item => {
      let hierarchy = getters.getProductionHierarchyById()(item)
      while (hierarchy.parent) {
        ascendants.push(hierarchy.parent)
        hierarchy = getters.getProductionHierarchyById()(hierarchy.parent)
      }
    })
    return ascendants
  },
  getProductionHierarchyChildren: () => (selectedIds) => {
    const { productionHierarchy } = useProductionHierarchyStore()
    const children = productionHierarchy.filter(
      item => selectedIds.includes(item.id)).map(item => item.children)
    return [...new Set(children)]
  },
}

const actions = {
  async fetchProductionHierarchy () {
    const { fetchProductionHierarchy } = useProductionHierarchyStore()
    await fetchProductionHierarchy()
  },
}

export default {
  actions,
  getters,
}
